import styled from "styled-components";
import ArrowRight from "../../../../assets/images/arrow-right.png";

const Styles = styled.div`
    .frame-295922858,
    .frame-295922858 * {
        box-sizing: border-box;
    }
    .frame-295922858 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-313325 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313319 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .check-map-list {
        color: #ffffff;
        text-align: center;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 14px;
        font-weight: 600;
        position: relative;
    }
    .choose-a-store-on-the-right-panel {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: center;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 10px;
        font-weight: 400;
        position: relative;
    }
    .frame-313500 {
        display: flex;
        flex-direction: column;
        gap: 13.5px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313499 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313324 {
        padding: 0px 15px 0px 15px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922857 {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 9999px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 44px;
        height: 44px;
        position: relative;
    }
    .arrow-right {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
    }
`;
const BOTagBodySelectStore = () => {
    return (
        <Styles style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center" }}>
            {" "}
            <div className="frame-313501">
                <div className="frame-313502">
                    <div className="frame-295922858">
                        <div className="frame-313325" style={{ flexDirection: "column" }}>
                            <div className="frame-313319">
                                <div className="check-map-list">Check map / list</div>
                            </div>
                            <div className="choose-a-store-on-the-right-panel">Choose a store on the right panel</div>
                        </div>
                        <div className="frame-313500">
                            <div className="frame-313499">
                                <div className="frame-313324">
                                    <div className="frame-295922857">
                                        <img className="arrow-right" src={ArrowRight} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Styles>
    );
};

export default BOTagBodySelectStore;
